import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { APIServiceProvider } from "../../common/services/api.service";
import { HelperServiceProvider } from "../../common/services/helper.service";

@Component({
	selector: "modal-customer",
	templateUrl: "./modal-customer.html"
})
export class CustomerModalPage {
	public customer = null;
	public order_data = null;
	public customer_data = null;

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public navParams: NavParams,
		public apiHelper: APIServiceProvider,
		public helperService: HelperServiceProvider
	) {
		this.getOrderDetails(this.navParams.get("order_id"));
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	getOrderDetails(order_id) {
		this.apiHelper.get(`v1.2/order/${order_id}`).subscribe(
			data => {
				this.order_data =
					data["data"].length != 0 ? data["data"] : null;
				if (this.order_data) {
					this.customer_data =
						this.order_data["order_customer_data"][
							"customer_data"
						] != undefined
							? JSON.parse(
									this.order_data["order_customer_data"][
										"customer_data"
									]
							  )
							: null;
				} else {
					this.helperService.presentToast(
						"Some error occurred, please try again"
					);
					this.viewCtrl.dismiss();
				}
			},
			err => {
				this.helperService.presentToast(
					"Some error occurred, please try again"
				);
				this.viewCtrl.dismiss();
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/modals/customer/customer.modal.ts